/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCommand } from './ClaimCommand';
import {
    ClaimCommandFromJSON,
    ClaimCommandFromJSONTyped,
    ClaimCommandToJSON,
    ClaimCommandToJSONTyped,
} from './ClaimCommand';

/**
 * 
 * @export
 * @interface UpdateCopropertyClaimsHistoryCommand
 */
export interface UpdateCopropertyClaimsHistoryCommand {
    /**
     * 
     * @type {Date}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    periodStart?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    periodEnd?: Date | null;
    /**
     * 
     * @type {Array<ClaimCommand>}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    claims: Array<ClaimCommand>;
    /**
     * Undertaking « Aucun sinistre n'a été déclaré sur les 3 dernières années » — offered when no claim is entered, required at contractualisation.
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    noClaimsLast3Years?: boolean | null;
    /**
     * Undertaking « Le risque n'est pas assuré et aucun sinistre n'est connu ».
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    notInsuredNoKnownClaims?: boolean | null;
    /**
     * Insurance history — was the building insured over the last 36 months?
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    insuredLast36Months: boolean;
    /**
     * Was the contract interrupted over the last 36 months?
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    coverageInterruptionLast36Months: boolean;
    /**
     * Start of the interruption — required when coverageInterruptionLast36Months is true.
     * @type {Date}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    coverageInterruptionStart?: Date | null;
    /**
     * End of the interruption — required when coverageInterruptionLast36Months is true.
     * @type {Date}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    coverageInterruptionEnd?: Date | null;
    /**
     * Was the contract terminated over the last 36 months?
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    terminationLast36Months: boolean;
    /**
     * Reason of the termination — required when terminationLast36Months is true.
     * @type {string}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    terminationReason?: string | null;
    /**
     * Mutual recourse waiver, including towards the insurer — false makes the coproperty not eligible.
     * @type {boolean}
     * @memberof UpdateCopropertyClaimsHistoryCommand
     */
    mutualRecourseWaiver: boolean;
}

/**
 * Check if a given object implements the UpdateCopropertyClaimsHistoryCommand interface.
 */
export function instanceOfUpdateCopropertyClaimsHistoryCommand(value: object): value is UpdateCopropertyClaimsHistoryCommand {
    if (!('claims' in value) || value['claims'] === undefined) return false;
    if (!('insuredLast36Months' in value) || value['insuredLast36Months'] === undefined) return false;
    if (!('coverageInterruptionLast36Months' in value) || value['coverageInterruptionLast36Months'] === undefined) return false;
    if (!('terminationLast36Months' in value) || value['terminationLast36Months'] === undefined) return false;
    if (!('mutualRecourseWaiver' in value) || value['mutualRecourseWaiver'] === undefined) return false;
    return true;
}

export function UpdateCopropertyClaimsHistoryCommandFromJSON(json: any): UpdateCopropertyClaimsHistoryCommand {
    return UpdateCopropertyClaimsHistoryCommandFromJSONTyped(json, false);
}

export function UpdateCopropertyClaimsHistoryCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCopropertyClaimsHistoryCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
        'claims': ((json['claims'] as Array<any>).map(ClaimCommandFromJSON)),
        'noClaimsLast3Years': json['noClaimsLast3Years'] == null ? undefined : json['noClaimsLast3Years'],
        'notInsuredNoKnownClaims': json['notInsuredNoKnownClaims'] == null ? undefined : json['notInsuredNoKnownClaims'],
        'insuredLast36Months': json['insuredLast36Months'],
        'coverageInterruptionLast36Months': json['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': json['coverageInterruptionStart'] == null ? undefined : (new Date(json['coverageInterruptionStart'])),
        'coverageInterruptionEnd': json['coverageInterruptionEnd'] == null ? undefined : (new Date(json['coverageInterruptionEnd'])),
        'terminationLast36Months': json['terminationLast36Months'],
        'terminationReason': json['terminationReason'] == null ? undefined : json['terminationReason'],
        'mutualRecourseWaiver': json['mutualRecourseWaiver'],
    };
}

export function UpdateCopropertyClaimsHistoryCommandToJSON(json: any): UpdateCopropertyClaimsHistoryCommand {
    return UpdateCopropertyClaimsHistoryCommandToJSONTyped(json, false);
}

export function UpdateCopropertyClaimsHistoryCommandToJSONTyped(value?: UpdateCopropertyClaimsHistoryCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart'] as any).toISOString()),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd'] as any).toISOString()),
        'claims': ((value['claims'] as Array<any>).map(ClaimCommandToJSON)),
        'noClaimsLast3Years': value['noClaimsLast3Years'],
        'notInsuredNoKnownClaims': value['notInsuredNoKnownClaims'],
        'insuredLast36Months': value['insuredLast36Months'],
        'coverageInterruptionLast36Months': value['coverageInterruptionLast36Months'],
        'coverageInterruptionStart': value['coverageInterruptionStart'] == null ? undefined : ((value['coverageInterruptionStart'] as any).toISOString()),
        'coverageInterruptionEnd': value['coverageInterruptionEnd'] == null ? undefined : ((value['coverageInterruptionEnd'] as any).toISOString()),
        'terminationLast36Months': value['terminationLast36Months'],
        'terminationReason': value['terminationReason'],
        'mutualRecourseWaiver': value['mutualRecourseWaiver'],
    };
}

